import React from 'react';
import { Box, IconButton } from '@mui/material';
import { FaWhatsapp, FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa';

const SocialSidebar = () => {
  const socialLinks = [
    {
      name: 'WhatsApp',
      icon: <FaWhatsapp size={18} />,
      url: 'https://wa.me/9168800800',
      color: '#25D366',
      bgColor: '#fff'
    },
    {
      name: 'Facebook',
      icon: <FaFacebookF size={18} />,
      url: 'https://www.facebook.com/profile.php?id=61587571352539',
      color: '#1877F2',
      bgColor: '#fff'
    },
    {
      name: 'Instagram',
      icon: <FaInstagram size={18} />,
      url: 'https://www.instagram.com/paritranam_ayurveda/',
      color: '#E4405F',
      bgColor: '#fff'
    },
    {
      name: 'YouTube',
      icon: <FaYoutube size={18} />,
      url: 'https://www.youtube.com/results?search_query=Paritranam+Ayurveda',
      color: '#FF0000',
      bgColor: '#fff'
    }
  ];

  return (
    <Box
      sx={{
        position: 'fixed',
        top: '50%',
        right: 0,
        transform: 'translateY(-50%)',
        zIndex: 1300,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        p: 1,
        bgcolor: 'rgba(255, 255, 255, 0.9)',
        borderTopLeftRadius: 12,
        borderBottomLeftRadius: 12,
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        backdropFilter: 'blur(4px)'
      }}
    >
      {socialLinks.map((link, index) => (
        <IconButton
          key={index}
          component="a"
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            width: 36,
            height: 36,
            bgcolor: link.bgColor,
            color: link.color,
            border: `1px solid ${link.color}20`,
            transition: 'all 0.3s ease',
            '&:hover': {
              bgcolor: link.color,
              color: '#fff',
              transform: 'translateX(-2px)',
              boxShadow: `0 4px 8px ${link.color}40`
            }
          }}
          aria-label={link.name}
        >
          {link.icon}
        </IconButton>
      ))}
    </Box>
  );
};

export default SocialSidebar;
